/** ****************************** Import URL constants ******************************* */



// import { get } from "lodash";
// import { createRoleAndAccess } from "./create";
// import { getRoleAndAccess } from "./list";

const URL_CONSTANTS     = {

    // ------------------------------- Auth End points -----------------------------

    login: "auth/login",
    googleLogin: "auth/googlelogin",
    forgotPassword: "auth/forgot-password",
    forgotPasswordReset: "auth/forgot-password-reset",
    resetPassword: "auth/reset-password",

    // -------------------------------  modules End points -----------------------------
    getAllModule: "admin-module/modules",

    // -----------------------  Roles and Access End points -----------------------------
    
    createRoleAndAccess: "admin-roles/create-roles",
    getRoles: "admin-roles",
    getallRoles: "admin-roles/get-all",
    updateRoleStatus: "admin-roles/update-status",
    deleteMultipleRole :"admin-roles/delete-multiple",
    
    // ------------------------------- User -----------------------------
    
    getUserList : "admin-user/users-list",
    createUser: "admin-user/create-users",
    updateUser: "admin-user/update-users",
    updateUserProfile: "admin-user/update-profile",
    updateStatusUser: "admin-user/update-status",
    deleteUser: "admin-user/delete-users",
    deleteMultipleUser: "admin-user/delete-multiple-users",
    userAccess:'admin-user/user',
    
    getRoleAndAccess: "admin-roles/roles-access", 
    deleteRole: "admin-roles/delete-roles",
    
    // ************************************//
    getAllergy:"allergy",
    
    // ------------------------------- patient lookup  -----------------------------
    
    getPatientLookup:"patients",
    getCountDetails:"patients/patient-count",
    getFacilities:"patients/facility",
    
    // ------------------------------- patient lookup  -----------------------------
    getMedication:"medications",
    getVitals:"observations",
    getImmuzations:"immunizations",
    getVitalsHistory:"observations/history",

    // ------------------------------- Error  notes  -----------------------------
    updateNotesErrorList:"progress-notes",
    originalPdfUrlNotesErrorList:"progress-notes/original-notes",
    multipleDeleteNotes:"progress-notes/multiple-delete",
    getNotesErrorList:"progress-notes/error-notes-list",
    getNotesErrorListByError:"error-notes",
    getRemovedNotesList:"error-notes/removed",
    getLocationsList:"progress-notes/notes-location",
    getSenderNameList:"progress-notes/notes-sender",
    getNotesTypeList:"progress-notes/notes-type",
    updateNotesSourceDetailsById:"error-notes/source-data",
    reExactNotesList:"error-notes/update-status",
    detectedPatientList:"error-notes/detected-patient-list",

    // ------------------------------- location mapping  -----------------------------
    getMappedLocationList:"mapped-locations",
    mappedPatient:"map-patient",
    
    // ---------------------------------- mapping notes type ----------------------
    getMappingNotesType:"progress-notes/type",
    deleteappingNotesType:"progress-notes/type-multiple-delete",

    // ---------------------------------- custom notes type ----------------------
    customNotesType:"custom-notes-type",
    deletecustomNotesType:"custom-notes-type/delete-multiple",


    // ---------------------------------- post notes ----------------------

    getAllCustomNoteType:"custom-notes-type/get-all",
    getPatientSearch:"patients/search",
    getPCCLocation:"pcc-locations",
    getSourceLocation:"source-locations",
    locationMapping:"map-location",

    // ---------------------------------- dashboard count ----------------------
    getDashboardCount:"dashboard",

    // ------------------------------------maapping ----------------------------
    updateNotesErrorByPatientDetails:"map-patient",
    updateNotesErrorByPatientDetailsById:"error-notes/update-patient-details",

    // --------------------------------- AI summary for notes ---------------------
    aiSummarizeFornotes:"ai-summarize",

    // --------------------------------- Nursing Summary ---------------------
    nursingSummaryUploadFiles: "nursing-summary/upload-files",
    nursingSummaryTextInput: "nursing-summary/text-input",
    nursingSummaryGetById: "nursing-summary/summary",
    nursingSummaryHealth: "nursing-summary/health",

    // --------------------------------- eFax ---------------------
    efaxCurd: "efax",
    deleteMultipleEfax: "efax/delete-multiple-efax",

    // --------------------------------- Auto Delete ---------------------
    autoDeleteConfigs: "auto-delete/configs",
    autoDeleteRunNow: "auto-delete/run-now",
    autoDeleteSchedule: "auto-delete/schedule",

}

export { URL_CONSTANTS };
